import {store} from "../../../storage/store";
import {append, destroy, destroyAll} from "../../../storage/drawermenu";
import {useSelector} from "react-redux";

export const useModal = () => useSelector(state => state.drawerMenu.modal);
export const createModal = (name, data = false) => store.dispatch(append({name, data}));
export const destroyModal = () => store.dispatch(destroy());
export const destroyAllModal = () => store.dispatch(destroyAll());